import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ShieldCheck, Download, Trash2, FileText } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const TYPE_ICON = { export: Download, delete: Trash2, correct: FileText, do_not_sell: ShieldCheck };

export default function DataRequestsPanel() {
  const qc = useQueryClient();
  const { data: reqs = [] } = useQuery({ queryKey: ["admin-data-requests"], queryFn: () => api.get("/data-requests").then((r) => r.data) });
  const setStatus = async (id, status) => {
    try { await api.put(`/data-requests/${id}/status`, { status }); toast.success("Updated — your changes are live"); qc.invalidateQueries({ queryKey: ["admin-data-requests"] }); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const badge = (s) => s === "resolved" ? "bg-[#5C8A72]/15 text-[#5C8A72]" : s === "in_progress" ? "bg-[#144F75]/10 text-[#144F75]" : "bg-[#D98E73]/15 text-[#B5794E]";
  return (
    <div data-testid="admin-data-requests-panel">
      <h2 className="font-serif text-2xl text-[#1A242B] mb-1">Privacy Requests</h2>
      <p className="text-sm text-[#4A5D6B] mb-5">Member data export / deletion / correction requests (GDPR/CCPA).</p>
      <div className="eyw-card divide-y divide-[#E5E0D8]">
        {reqs.map((r) => {
          const Icon = TYPE_ICON[r.type] || FileText;
          return (
            <div key={r.id} className="p-4 flex items-center justify-between gap-3" data-testid={`data-request-${r.id}`}>
              <div className="flex items-start gap-3">
                <Icon size={18} className="text-[#144F75] mt-0.5" />
                <div>
                  <div className="text-sm font-semibold text-[#1A242B]">{r.type.replace("_", " ")} · {r.name || r.email}</div>
                  <div className="text-xs text-[#4A5D6B]">{r.email}{r.detail && ` · ${r.detail}`}</div>
                  <div className="text-xs text-[#8FA89B]">{r.created_at?.slice(0, 10)}</div>
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className={`text-xs px-2.5 py-1 rounded-full ${badge(r.status)}`}>{r.status}</span>
                {r.status !== "resolved" && (<>
                  {r.status === "open" && <button onClick={() => setStatus(r.id, "in_progress")} className="eyw-btn-ghost !py-1 !px-3 text-xs">Start</button>}
                  <button onClick={() => setStatus(r.id, "resolved")} data-testid={`data-request-resolve-${r.id}`} className="eyw-btn !py-1 !px-3 text-xs">Resolve</button>
                </>)}
              </div>
            </div>
          );
        })}
        {reqs.length === 0 && <p className="text-[#4A5D6B] text-sm p-4">No privacy requests.</p>}
      </div>
    </div>
  );
}
